"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.TagContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: fit-content;\n  padding: 4px 4px;\n  background: ", ";\n  font-size: 12px;\n  color: ", ";\n  letter-spacing: 0;\n  line-height: 16px;\n  text-align: center;\n  margin-left: auto;\n"], ["\n  width: fit-content;\n  padding: 4px 4px;\n  background: ",
    ";\n  font-size: 12px;\n  color: ", ";\n  letter-spacing: 0;\n  line-height: 16px;\n  text-align: center;\n  margin-left: auto;\n"])), function (_a) {
    var colours = _a.theme.colours, backgroundColor = _a.backgroundColor;
    return backgroundColor ? backgroundColor : colours.tag.backgroundColor;
}, function (_a) {
    var colours = _a.theme.colours, textColor = _a.textColor;
    return (textColor ? textColor : colours.tag.textColor);
});
exports.TagContainer.displayName = 'TagContainer';
var Tag = function (_a) {
    var text = _a.text, backgroundColor = _a.backgroundColor, textColor = _a.textColor;
    return (react_1.default.createElement(exports.TagContainer, { backgroundColor: backgroundColor, textColor: textColor }, text));
};
Tag.displayName = 'Tag';
exports.default = Tag;
var templateObject_1;
